const chains = [];
chains.push({ _operation: 'getDebtSheetRecordsByExternalPartyIdAndSaleType', api: '/debt-sheet-records/:externalPartyId/:saleType', defaultData: [], httpVerb: 'get' });
export default chains;
